export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      partners: 'Partners',
      contact: 'Contact'
    },
    hero: {
      title: 'Bridging Sovereign Capital & Swiss Precision',
      subtitle: 'Your Institutional Gateway from the Gulf to the heart of Europe',
      cta: 'Explore Opportunities',
      secondary: 'Contact Us'
    },
    about: {
      title: 'About Arabic Alps',
      description: 'Arabic Alps serves as the premier institutional gateway connecting sovereign capital from the Gulf region with Swiss precision and European excellence. We specialize in facilitating high-value investments, strategic partnerships, and exclusive opportunities for institutional clients and high-net-worth individuals.',
      vision: 'Our Vision',
      visionText: 'To be the most trusted bridge between Middle Eastern sovereign wealth and European investment excellence, fostering prosperity through expertise, integrity, and cultural understanding.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive institutional solutions tailored for sophisticated investors',
      service1: {
        title: 'Capital Deployment & Investment Structuring',
        description: 'Strategic advisory on sovereign wealth allocation, deal structuring, and investment vehicles tailored for institutional clients seeking European market exposure.'
      },
      service2: {
        title: 'Cross-Border M&A Advisory',
        description: 'Comprehensive merger and acquisition advisory services, due diligence coordination, and transaction structuring for Gulf-Europe business combinations.'
      },
      service3: {
        title: 'Prime Real Estate Solutions',
        description: 'Curated access to exclusive Swiss and European property portfolios, including off-market luxury assets, commercial developments, and strategic land acquisitions.'
      },
      service4: {
        title: 'Market Entry & Expansion',
        description: 'End-to-end support for institutional market entry strategies, regulatory compliance navigation, and local partnership facilitation across Gulf and European markets.'
      },
      service5: {
        title: 'Institutional Relationship Management',
        description: 'Ongoing portfolio oversight, stakeholder coordination, and dedicated relationship management for sovereign wealth funds, family offices, and institutional investors.'
      },
      service6: {
        title: 'Government & Regulatory Affairs',
        description: 'Strategic engagement with government officials, regulatory bodies, and policy makers to facilitate high-level institutional transactions and ensure compliance excellence.'
      }
    },
    partners: {
      title: 'Our Managing Partners',
      subtitle: 'Leadership with deep expertise in Gulf and European markets',
      partner1: 'Managing Partner',
      partner2: 'Managing Partner'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Connect with us to explore exclusive investment opportunities',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      company: 'Company / Institution',
      message: 'Your Message',
      send: 'Send Message',
      info: 'Contact Information',
      address: 'Zurich, Switzerland',
      success: 'Message sent successfully! We will contact you soon.',
      error: 'Failed to send message. Please try again.'
    },
    footer: {
      tagline: 'Bridging Gulf Capital with European Excellence',
      rights: 'All rights reserved.',
      links: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      services: 'Dienstleistungen',
      partners: 'Partner',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Verbindung von Staatskapital und Schweizer Präzision',
      subtitle: 'Ihr institutionelles Gateway vom Golf ins Herz Europas',
      cta: 'Chancen erkunden',
      secondary: 'Kontaktieren Sie uns'
    },
    about: {
      title: 'Über Arabic Alps',
      description: 'Arabic Alps dient als erstklassiges institutionelles Gateway, das Staatskapital aus der Golfregion mit Schweizer Präzision und europäischer Exzellenz verbindet. Wir sind spezialisiert auf hochwertige Investitionen, strategische Partnerschaften und exklusive Möglichkeiten für institutionelle Kunden und vermögende Privatpersonen.',
      vision: 'Unsere Vision',
      visionText: 'Die vertrauenswürdigste Brücke zwischen nahöstlichem Staatsvermögen und europäischer Investmentexzellenz zu sein und durch Expertise, Integrität und kulturelles Verständnis Wohlstand zu fördern.'
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Umfassende institutionelle Lösungen für anspruchsvolle Investoren',
      service1: {
        title: 'Kapitalallokation & Investitionsstrukturierung',
        description: 'Strategische Beratung zur Allokation von Staatsvermögen, Deal-Strukturierung und maßgeschneiderte Investmentvehikel für institutionelle Kunden mit europäischem Marktengagement.'
      },
      service2: {
        title: 'Grenzüberschreitende M&A-Beratung',
        description: 'Umfassende Beratung zu Fusionen und Übernahmen, Koordination der Due Diligence und Transaktionsstrukturierung für Golf-Europa-Unternehmenskombinationen.'
      },
      service3: {
        title: 'Erstklassige Immobilienlösungen',
        description: 'Kuratierter Zugang zu exklusiven Schweizer und europäischen Immobilienportfolios, einschließlich Off-Market-Luxusobjekten, Gewerbeentwicklungen und strategischen Landakquisitionen.'
      },
      service4: {
        title: 'Markteintritt & Expansion',
        description: 'Umfassende Unterstützung für institutionelle Markteintrittsstrategien, Navigation regulatorischer Compliance und Vermittlung lokaler Partnerschaften in Golf- und europäischen Märkten.'
      },
      service5: {
        title: 'Institutionelles Beziehungsmanagement',
        description: 'Laufende Portfolio-Überwachung, Stakeholder-Koordination und dediziertes Beziehungsmanagement für Staatsfonds, Family Offices und institutionelle Investoren.'
      },
      service6: {
        title: 'Regierungs- & Regulierungsangelegenheiten',
        description: 'Strategisches Engagement mit Regierungsbeamten, Aufsichtsbehörden und politischen Entscheidungsträgern zur Erleichterung hochrangiger institutioneller Transaktionen und Gewährleistung regulatorischer Exzellenz.'
      }
    },
    partners: {
      title: 'Unsere Geschäftsführenden Partner',
      subtitle: 'Führung mit tiefgreifender Expertise in Golf- und europäischen Märkten',
      partner1: 'Geschäftsführender Partner',
      partner2: 'Geschäftsführender Partner'
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Verbinden Sie sich mit uns, um exklusive Investitionsmöglichkeiten zu erkunden',
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      company: 'Unternehmen / Institution',
      message: 'Ihre Nachricht',
      send: 'Nachricht senden',
      info: 'Kontaktinformationen',
      address: 'Zürich, Schweiz',
      success: 'Nachricht erfolgreich gesendet! Wir werden Sie bald kontaktieren.',
      error: 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.'
    },
    footer: {
      tagline: 'Verbindung von Golfkapital mit europäischer Exzellenz',
      rights: 'Alle Rechte vorbehalten.',
      links: 'Schnelllinks',
      legal: 'Rechtliches',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'خدماتنا',
      partners: 'الشركاء',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'ربط رأس المال السيادي بالدقة السويسرية',
      subtitle: 'بوابتك المؤسسية من الخليج إلى قلب أوروبا',
      cta: 'استكشف الفرص',
      secondary: 'اتصل بنا'
    },
    about: {
      title: 'عن ألب العربية',
      description: 'تعمل ألب العربية كبوابة مؤسسية رائدة تربط رأس المال السيادي من منطقة الخليج بالدقة السويسرية والتميز الأوروبي. نحن متخصصون في تسهيل الاستثمارات عالية القيمة والشراكات الاستراتيجية والفرص الحصرية للعملاء المؤسسيين وأصحاب الثروات العالية.',
      vision: 'رؤيتنا',
      visionText: 'أن نكون الجسر الأكثر موثوقية بين الثروة السيادية في الشرق الأوسط والتميز الاستثماري الأوروبي، لتعزيز الازدهار من خلال الخبرة والنزاهة والتفاهم الثقافي.'
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول مؤسسية شاملة مصممة للمستثمرين المتطورين',
      service1: {
        title: 'نشر رأس المال وهيكلة الاستثمار',
        description: 'استشارات استراتيجية حول تخصيص الثروة السيادية، وهيكلة الصفقات، وأدوات الاستثمار المصممة خصيصاً للعملاء المؤسسيين الذين يسعون للتعرض للسوق الأوروبية.'
      },
      service2: {
        title: 'الاستشارات في الاندماج والاستحواذ عبر الحدود',
        description: 'خدمات استشارية شاملة للاندماج والاستحواذ، وتنسيق العناية الواجبة، وهيكلة المعاملات للمجموعات التجارية بين الخليج وأوروبا.'
      },
      service3: {
        title: 'حلول العقارات الممتازة',
        description: 'وصول منسق إلى محافظ عقارية سويسرية وأوروبية حصرية، بما في ذلك الأصول الفاخرة خارج السوق والتطويرات التجارية والاستحواذات الأراضي الاستراتيجية.'
      },
      service4: {
        title: 'دخول السوق والتوسع',
        description: 'دعم شامل لاستراتيجيات دخول السوق المؤسسية، والتنقل في الامتثال التنظيمي، وتسهيل الشراكات المحلية في أسواق الخليج وأوروبا.'
      },
      service5: {
        title: 'إدارة العلاقات المؤسسية',
        description: 'إشراف مستمر على المحفظة، وتنسيق أصحاب المصلحة، وإدارة علاقات مخصصة لصناديق الثروة السيادية والمكاتب العائلية والمستثمرين المؤسسيين.'
      },
      service6: {
        title: 'الشؤون الحكومية والتنظيمية',
        description: 'المشاركة الاستراتيجية مع المسؤولين الحكوميين والهيئات التنظيمية وصناع السياسات لتسهيل المعاملات المؤسسية رفيعة المستوى وضمان التميز في الامتثال.'
      }
    },
    partners: {
      title: 'شركاؤنا الإداريون',
      subtitle: 'قيادة بخبرة عميقة في أسواق الخليج وأوروبا',
      partner1: 'شريك إداري',
      partner2: 'شريك إداري'
    },
    contact: {
      title: 'تواصل معنا',
      subtitle: 'تواصل معنا لاستكشاف فرص الاستثمار الحصرية',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      company: 'الشركة / المؤسسة',
      message: 'رسالتك',
      send: 'إرسال الرسالة',
      info: 'معلومات الاتصال',
      address: 'زيورخ، سويسرا',
      success: 'تم إرسال الرسالة بنجاح! سنتواصل معك قريبًا.',
      error: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.'
    },
    footer: {
      tagline: 'ربط رأس المال الخليجي بالتميز الأوروبي',
      rights: 'جميع الحقوق محفوظة.',
      links: 'روابط سريعة',
      legal: 'قانوني',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      partners: 'Partenaires',
      contact: 'Contact'
    },
    hero: {
      title: 'Relier le Capital Souverain et la Précision Suisse',
      subtitle: 'Votre Passerelle Institutionnelle du Golfe au Cœur de l\'Europe',
      cta: 'Explorer les Opportunités',
      secondary: 'Nous Contacter'
    },
    about: {
      title: 'À propos d\'Arabic Alps',
      description: 'Arabic Alps est la passerelle institutionnelle de premier plan reliant le capital souverain de la région du Golfe à la précision suisse et à l\'excellence européenne. Nous nous spécialisons dans la facilitation d\'investissements de grande valeur, de partenariats stratégiques et d\'opportunités exclusives pour les clients institutionnels et les particuliers fortunés.',
      vision: 'Notre Vision',
      visionText: 'Être le pont le plus fiable entre la richesse souveraine du Moyen-Orient et l\'excellence des investissements européens, favorisant la prospérité par l\'expertise, l\'intégrité et la compréhension culturelle.'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Solutions institutionnelles complètes adaptées aux investisseurs sophistiqués',
      service1: {
        title: 'Déploiement de Capital & Structuration d\'Investissement',
        description: 'Conseil stratégique sur l\'allocation de richesse souveraine, structuration de transactions et véhicules d\'investissement sur mesure pour clients institutionnels recherchant une exposition au marché européen.'
      },
      service2: {
        title: 'Conseil en Fusions-Acquisitions Transfrontalières',
        description: 'Services conseil complets en fusions et acquisitions, coordination de due diligence et structuration de transactions pour combinaisons d\'entreprises Golfe-Europe.'
      },
      service3: {
        title: 'Solutions Immobilières de Prestige',
        description: 'Accès organisé à des portefeuilles immobiliers suisses et européens exclusifs, incluant actifs de luxe hors marché, développements commerciaux et acquisitions foncières stratégiques.'
      },
      service4: {
        title: 'Entrée sur le Marché & Expansion',
        description: 'Support complet pour stratégies d\'entrée sur le marché institutionnel, navigation de conformité réglementaire et facilitation de partenariats locaux dans les marchés du Golfe et européens.'
      },
      service5: {
        title: 'Gestion des Relations Institutionnelles',
        description: 'Supervision continue de portefeuille, coordination des parties prenantes et gestion de relations dédiée pour fonds souverains, family offices et investisseurs institutionnels.'
      },
      service6: {
        title: 'Affaires Gouvernementales & Réglementaires',
        description: 'Engagement stratégique avec responsables gouvernementaux, organismes de réglementation et décideurs politiques pour faciliter transactions institutionnelles de haut niveau et assurer excellence en conformité.'
      }
    },
    partners: {
      title: 'Nos Associés Gérants',
      subtitle: 'Leadership avec une expertise approfondie des marchés du Golfe et européens',
      partner1: 'Associé Gérant',
      partner2: 'Associé Gérant'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Connectez-vous avec nous pour explorer des opportunités d\'investissement exclusives',
      name: 'Nom Complet',
      email: 'Adresse E-mail',
      phone: 'Numéro de Téléphone',
      company: 'Entreprise / Institution',
      message: 'Votre Message',
      send: 'Envoyer le Message',
      info: 'Informations de Contact',
      address: 'Zurich, Suisse',
      success: 'Message envoyé avec succès! Nous vous contacterons bientôt.',
      error: 'Échec de l\'envoi du message. Veuillez réessayer.'
    },
    footer: {
      tagline: 'Relier le Capital du Golfe à l\'Excellence Européenne',
      rights: 'Tous droits réservés.',
      links: 'Liens Rapides',
      legal: 'Juridique',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation'
    }
  },
  it: {
    nav: {
      home: 'Home',
      about: 'Chi Siamo',
      services: 'Servizi',
      partners: 'Partner',
      contact: 'Contatti'
    },
    hero: {
      title: 'Collegare il Capitale Sovrano e la Precisione Svizzera',
      subtitle: 'Il Tuo Gateway Istituzionale dal Golfo al Cuore dell\'Europa',
      cta: 'Esplora le Opportunità',
      secondary: 'Contattaci'
    },
    about: {
      title: 'Su Arabic Alps',
      description: 'Arabic Alps funge da gateway istituzionale di primo piano che collega il capitale sovrano dalla regione del Golfo con la precisione svizzera e l\'eccellenza europea. Siamo specializzati nel facilitare investimenti di alto valore, partnership strategiche e opportunità esclusive per clienti istituzionali e individui ad alto patrimonio.',
      vision: 'La Nostra Visione',
      visionText: 'Essere il ponte più affidabile tra la ricchezza sovrana del Medio Oriente e l\'eccellenza degli investimenti europei, promuovendo la prosperità attraverso competenza, integrità e comprensione culturale.'
    },
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Soluzioni istituzionali complete su misura per investitori sofisticati',
      service1: {
        title: 'Impiego di Capitale & Strutturazione degli Investimenti',
        description: 'Consulenza strategica sull\'allocazione di ricchezza sovrana, strutturazione di accordi e veicoli di investimento personalizzati per clienti istituzionali che cercano esposizione al mercato europeo.'
      },
      service2: {
        title: 'Consulenza M&A Transfrontaliera',
        description: 'Servizi di consulenza completa su fusioni e acquisizioni, coordinamento di due diligence e strutturazione di transazioni per combinazioni aziendali Golfo-Europa.'
      },
      service3: {
        title: 'Soluzioni Immobiliari di Prestigio',
        description: 'Accesso curato a portafogli immobiliari svizzeri ed europei esclusivi, inclusi asset di lusso fuori mercato, sviluppi commerciali e acquisizioni fondiarie strategiche.'
      },
      service4: {
        title: 'Ingresso sul Mercato & Espansione',
        description: 'Supporto completo per strategie di ingresso sul mercato istituzionale, navigazione di conformità normativa e facilitazione di partnership locali nei mercati del Golfo ed europei.'
      },
      service5: {
        title: 'Gestione delle Relazioni Istituzionali',
        description: 'Supervisione continua del portafoglio, coordinamento degli stakeholder e gestione dedicata delle relazioni per fondi sovrani, family office e investitori istituzionali.'
      },
      service6: {
        title: 'Affari Governativi & Regolamentari',
        description: 'Impegno strategico con funzionari governativi, organismi di regolamentazione e decisori politici per facilitare transazioni istituzionali di alto livello e garantire eccellenza nella conformità.'
      }
    },
    partners: {
      title: 'I Nostri Managing Partner',
      subtitle: 'Leadership con profonda esperienza nei mercati del Golfo ed europei',
      partner1: 'Managing Partner',
      partner2: 'Managing Partner'
    },
    contact: {
      title: 'Contattaci',
      subtitle: 'Collegati con noi per esplorare opportunità di investimento esclusive',
      name: 'Nome Completo',
      email: 'Indirizzo Email',
      phone: 'Numero di Telefono',
      company: 'Azienda / Istituzione',
      message: 'Il Tuo Messaggio',
      send: 'Invia Messaggio',
      info: 'Informazioni di Contatto',
      address: 'Zurigo, Svizzera',
      success: 'Messaggio inviato con successo! Ti contatteremo presto.',
      error: 'Invio del messaggio fallito. Riprova.'
    },
    footer: {
      tagline: 'Collegare il Capitale del Golfo con l\'Eccellenza Europea',
      rights: 'Tutti i diritti riservati.',
      links: 'Link Rapidi',
      legal: 'Legale',
      privacy: 'Politica sulla Privacy',
      terms: 'Termini di Servizio'
    }
  }
};
